/*!

=========================================================
* Paper Kit React - v1.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/paper-kit-react

* Copyright 2020 Creative Tim (https://www.creative-tim.com)
* Licensed under MIT (https://github.com/creativetimofficial/paper-kit-react/blob/master/LICENSE.md)

* Coded by Creative Tim

=========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.

*/
import React from "react";
import { Link } from "react-router-dom";
// nodejs library that concatenates strings
import classnames from "classnames";

// reactstrap components
import {
  Collapse,
  NavbarBrand,
  Navbar,
  NavItem,
  NavLink,
  Nav,
  Container,
} from "reactstrap";

function ExamplesNavbar() {
  const [navbarColor, setNavbarColor] = React.useState("navbar-transparent");
  const [navbarCollapse, setNavbarCollapse] = React.useState(false);

  const toggleNavbarCollapse = () => {
    setNavbarCollapse(!navbarCollapse);
    document.documentElement.classList.toggle("nav-open");
  };

  React.useEffect(() => {
    const updateNavbarColor = () => {
      if (
        document.documentElement.scrollTop > 299 ||
        document.body.scrollTop > 299
      ) {
        setNavbarColor("");
      } else if (
        document.documentElement.scrollTop < 300 ||
        document.body.scrollTop < 300
      ) {
        setNavbarColor("navbar-transparent");
      }
    };

    window.addEventListener("scroll", updateNavbarColor);

    return function cleanup() {
      window.removeEventListener("scroll", updateNavbarColor);
    };
  });
  return (
    <Navbar
        className={classnames("fixed-top", navbarColor)}
        color-on-scroll="300"
        expand="lg"
    >
        <Container>
            <div className="navbar-translate">
                <NavbarBrand
                    data-placement="bottom"
                    to="/"
                    target="_blank"
                    title="IET MBCET"
                    tag={Link}
                >
                    OUTREACH 150
                </NavbarBrand>
                <button
                    aria-expanded={navbarCollapse}
                    className={classnames("navbar-toggler navbar-toggler", {
                        toggled: navbarCollapse,
                    })}
                    onClick={toggleNavbarCollapse}
                >
                    <span className="navbar-toggler-bar bar1" />
                    <span className="navbar-toggler-bar bar2" />
                    <span className="navbar-toggler-bar bar3" />
                </button>
            </div>
            <Collapse
                className="justify-content-end"
                navbar
                isOpen={navbarCollapse}
            >
                <Nav navbar>
                    <NavItem>
                        <NavLink
                            data-placement="bottom"
                            href="https://www.facebook.com/ietmbcet"
                            target="_blank"
                            title="Like us on Facebook"
                        >
                            <i className="fa fa-facebook-square" />
                            <p className="d-lg-none">Facebook</p>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            data-placement="bottom"
                            href="https://www.instagram.com/ietmbcet/"
                            target="_blank"
                            title="Follow us on Instagram"
                        >
                            <i className="fa fa-instagram" />
                            <p className="d-lg-none">Instagram</p>
                        </NavLink>
                    </NavItem>
                    <NavItem>
                        <NavLink
                            data-placement="bottom"
                            href="https://www.linkedin.com/showcase/iet-mbcet/"
                            target="_blank"
                            title="Follow us on LinkedIn"
                        >
                            <i className="fa fa-linkedin" />
                            <p className="d-lg-none">LinkedIn</p>
                        </NavLink>
                    </NavItem>
                </Nav>
            </Collapse>
        </Container>
    </Navbar>
  );
}

export default ExamplesNavbar;
